import {useState} from 'react';

import {useProfileRecentOrdersQuery} from '#apollo/schema';
import {Accordion, Button, Text} from '#component/base';
import RectangleSkeleton from '#component/base/skeletons/RectangleSkeleton';
import {AccordionRoot} from '#component/util';
import {useViewportSize} from '#hook';
import {sprinkles} from '#style/sprinkles';
import {formattedDate} from '#util';

import OrderDetailWithFixed from '../UpcomingOrder/OrderDetailWithFixed';
import OrderTotals from '../UpcomingOrder/OrderTotals';
import {
  accordionTriggerCustomBtn,
  accordionWrapperInner,
  upcomingOrderHeadingText,
} from '../UpcomingOrder/UpcomingOrder.css';
import HeadingRecent from './HeadingRecent';
import {isOrderFulfilled} from './RecentOrders.util';

import {
  accordionWrapperRecent,
  btnLoadMore,
  recentOrderWrapper,
  recentOrderWrapperInner,
} from './RecentOrders.css';

const RecentOrders = () => {
  const [isLoadMore, setIsLoadMore] = useState(false);
  const {isMobile} = useViewportSize();
  const {data, loading} = useProfileRecentOrdersQuery();
  const {me} = data || {};
  const {customerAccount} = me || {};
  const {orders} = customerAccount || {};
  const ordersFiltered = isLoadMore ? orders : orders?.slice(0, 3);

  if (!loading && !orders?.length) return null;
  return !loading ? (
    <div className={recentOrderWrapper}>
      <div className={recentOrderWrapperInner}>
        <Text as="h1" variant="heading3" color="burgundy" className={upcomingOrderHeadingText}>
          Recent Orders{' '}
        </Text>
        {!isMobile && (
          <HeadingRecent
            heading1="Order"
            heading2="Billing date"
            heading3="Status"
            heading4="fulfillment"
            isAccordion={false}
          />
        )}
        <AccordionRoot collapsible type="single" className={sprinkles({width: 'full'})}>
          {ordersFiltered?.map((order, index) => (
            <Accordion
              key={index}
              className={accordionWrapperRecent}
              triggerClassName={accordionWrapperInner}
              buttonClassName={accordionTriggerCustomBtn}
              trigger={
                <HeadingRecent
                  heading1={order?.name}
                  heading2={order && formattedDate(order?.billingDate)}
                  heading3={order?.status}
                  heading4={isOrderFulfilled(order) ? 'fulfilled' : 'unfulfilled'}
                />
              }
              value={order.id.toString()}>
              <div
                className={sprinkles({flex: 'flex', dir: 'col', gap: 20, pX: 20, width: 'full'})}>
                <OrderDetailWithFixed order={order} isNotUpcomingOrder />
                <OrderTotals order={order} isNotUpcomingOrder />
              </div>
            </Accordion>
          ))}
        </AccordionRoot>
        <div className={sprinkles({flex: 'flex', content: 'center'})}>
          {ordersFiltered && ordersFiltered?.length > 3 && (
            <Button
              variant="secondary"
              onClick={() => setIsLoadMore(!isLoadMore)}
              className={btnLoadMore}>
              {' '}
              <Text variant="body" color="eggplantDark">
                {isLoadMore ? 'View less orders' : 'View all orders'}
              </Text>
            </Button>
          )}
        </div>
      </div>
    </div>
  ) : (
    <RectangleSkeleton width={1400} height={400} />
  );
};

export default RecentOrders;
